





























import {
  Component,
  Prop,
  Vue
} from 'vue-property-decorator';
import {
  EssenceItemDto,
  OrderTemplateDto,
  ProductDto
} from '@eurogast/hub-client-typescript';
import ResultShoppingCartControl from '@/search-result/ResultShoppingCartControl.vue';
import EssenceApiService from '@/services/essences/EssenceApiService';
import OrderTemplateApiService from '@/services/order-templates/OrderTemplateApiService';
import { LinkUtil } from '@/services/LinkUtil';

@Component({
  components: {ResultShoppingCartControl}
})
export default class NotificationProductAttachments extends Vue {
  @Prop({required: false, default: () => []})
  public products: ProductDto[];

  private essenceService = EssenceApiService.singleton();
  private orderTemplateService = OrderTemplateApiService.singleton();

  public essenceMap = new Map<string, EssenceItemDto[]>();
  public orderTemplates: OrderTemplateDto[] = [];

  public async mounted() {
    await Promise.all([
          this.fetchEssenceMap(),
          this.fetchOrderTemplates()
        ]
    );
  }

  private async fetchEssenceMap() {
    this.essenceMap = await this.essenceService.fetchEssenceMap(this.products);
  }

  private async fetchOrderTemplates() {
    this.orderTemplates = await this.orderTemplateService.fetchOrderTemplates();
  }

  public findImagePath(product: ProductDto): string {
    return LinkUtil.getProductImageUrl(product);
  }
}
